import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuth } from '@clerk/vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/CarCatalog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/cars',
    name: 'Cars',
    component: () => import('../views/CarCatalog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/car-kits',
    name: 'CarKits',
    component: () => import('../views/CarKits.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/car-models',
    name: 'CarModels',
    component: () => import('../views/CarModels.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/standard-equipment',
    name: 'StandardEquipment',
    component: () => import('../views/StandardEquipment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chat-logs',
    name: 'ChatLogs',
    component: () => import('../views/ChatLogs.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/llm-prompt',
    name: 'LlmPrompt',
    component: () => import('../views/LlmPrompt.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/model/:id(\\d+)',
    name: 'modelDetailed',
    component: () => import('../views/CarModelDetailed.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded.value) {
    await waitIsLoaded();
  }

  if (to.meta.requiresAuth && !isSignedIn.value) {
    next({ path: '/sign-in' });
  } else {
    next();
  }
});

function waitIsLoaded() {
  const { isLoaded } = useAuth();

  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (isLoaded.value) {
        clearInterval(interval);
        resolve(1);
      }
    }, 50);
  });
}

export default router
